import React from 'react';
import { Box, CardMedia } from '@material-ui/core';
import HomeIconLight from '../../../../../assets/HomeIconLight.svg';
import { useSelector } from 'react-redux';
import classnames from 'classnames/bind';
import styles from './gallery.module.css';
import SvgHomeIcon from '../../../../../assets/SvgHomeIcon';

const cx = classnames.bind(styles);

const GalleryDetailsTab = ({ styles }) => {
  const { galleryImages } = useSelector((state) => {
    const { approvalManagementReducer } = state;
    return {
      galleryImages:
        approvalManagementReducer && approvalManagementReducer.data,
    };
  });

  return (
    <Box className={styles.section}>
      <Box className={cx('imageContainer')}>
        {galleryImages &&
          Array.isArray(galleryImages.imageFullUrls) &&
          galleryImages.imageFullUrls.map((item, pos) => {
            return (
              <Box
                key={pos}
                style={{ border: '1px solid #dfdfdf' }}
                className={cx('galleryItem')}>
                <CardMedia
                  className={cx('galleryImg')}
                  image={item}
                  title="Gallery-img"
                  component="img"
                  id={item}
                />
                <Box
                  display="flex"
                  flexDirection="row"
                  className={cx('galleryImgHomeIcon')}>
                  <Box className={cx('galleryItemIcon')}>
                    <Box className={cx('galleryImgHomeIcon')}>
                      {item === galleryImages.bannerFullUrl ? (
                        <Box className={cx('newSvg')}>
                          <SvgHomeIcon fill="#FE4500" />
                        </Box>
                      ) : (
                        <CardMedia
                          className={cx('galleryImgHomeIconImg')}
                          image={HomeIconLight}
                          title="Home-icon"
                          component="img"
                        />
                      )}
                    </Box>
                  </Box>
                </Box>
              </Box>
            );
          })}
      </Box>
    </Box>
  );
};

export default GalleryDetailsTab;
